import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Location } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class GlobalModalService {
  private companyIdSubject = new Subject<string | undefined>();

  companyId$ = this.companyIdSubject.asObservable();
  public companyId?: number;
  displayCompanyDetails: boolean = false;

  private previousUrl: string | null = null;

  constructor(private location: Location) {}

  openCompanyModal(companyId: string) {
    // Ensure we save a non-empty current path
    const currentPath = this.location.path() || window.location.pathname;
    if(!currentPath?.startsWith('/company'))
      this.previousUrl = currentPath;

    // Replace the URL without navigation
    this.location.replaceState(`company/${companyId}`);

    this.companyIdSubject.next(companyId);
    this.companyId = parseInt(companyId, 10);
    this.displayCompanyDetails = true;
  }

  close() {
    this.companyIdSubject.next(undefined);
    this.displayCompanyDetails = false;
    this.companyId = undefined;

    const currentPath = this.location.path() || window.location.pathname;
    if(currentPath?.startsWith('/company')){
      if (this.previousUrl !== null) {
        this.location.replaceState(this.previousUrl);
        this.previousUrl = null;
      }
    }
  }
}
